var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:'menu'},[_c('TheMenuLevel',{attrs:{"items":_vm.menu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }